import { render, staticRenderFns } from "./CrossSellItem.vue?vue&type=template&id=92c4491a"
import script from "./CrossSellItem.vue?vue&type=script&lang=ts"
export * from "./CrossSellItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports